// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var unsignedIntegerRegExp = /^[0-9]+$/;
var toOptionalU64 = function (value) {
    var parsed = typeof value === "number"
        ? value
        : typeof value === "string" && unsignedIntegerRegExp.test(value)
            ? Number(value)
            : undefined;
    return typeof parsed === "number" && Number.isSafeInteger(parsed) && parsed >= 0
        ? parsed
        : undefined;
};
var normalizeInvalidVotes = function (invalidVotes) {
    return invalidVotes
        ? {
            total_invalid: toOptionalU64(invalidVotes.total_invalid),
            implicit_invalid: toOptionalU64(invalidVotes.implicit_invalid),
            explicit_invalid: toOptionalU64(invalidVotes.explicit_invalid),
        }
        : undefined;
};
var normalizeCandidateResults = function (candidateResults) {
    return Object.fromEntries(Object.entries(candidateResults !== null && candidateResults !== void 0 ? candidateResults : {}).map(function (_a) {
        var candidateId = _a[0], result = _a[1];
        return [
            candidateId,
            __assign(__assign({}, result), { total_votes: toOptionalU64(result.total_votes) }),
        ];
    }));
};
/**
 * Keeps transient form values safe for the Rust/WASM u64 boundary. Text inputs and
 * old local-storage drafts can contain numeric strings or an empty string even though
 * the public TypeScript model only exposes numbers.
 */
export var normalizeAreaContestResults = function (content) { return (__assign(__assign({}, content), { total_votes: toOptionalU64(content.total_votes), total_valid_votes: toOptionalU64(content.total_valid_votes), invalid_votes: normalizeInvalidVotes(content.invalid_votes), total_blank_votes: toOptionalU64(content.total_blank_votes), blank_ballots: toOptionalU64(content.blank_ballots), census: toOptionalU64(content.census), candidate_results: normalizeCandidateResults(content.candidate_results) })); };
